import { render, staticRenderFns } from "./VoiceTextArea.vue?vue&type=template&id=03cc2c44&"
import script from "./VoiceTextArea.vue?vue&type=script&lang=js&"
export * from "./VoiceTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports